import { API_URL_FAQ } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditPartner from "types/Partner/createEditPartner";

const createFaq = (newfaq: TCreateEditPartner) =>
  apiInstance({
    url: API_URL_FAQ,
    method: "post",
    data: newfaq,
  });

export default createFaq;
